import { Lightning, Utils } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

export class CmsFolderIcon extends Lightning.Component {
  static _template() {
    return {
      w: 32,
      h: 30,
      Icon: {
        src: Utils.asset('images/recording/recording-folder.png'),
        w: w => w,
        h: h => h,
      },
      Amount: {
        x: w => w / 2,
        y: h => h / 2,
        mountX: 0.5,
        mountY: 0.35,
        text: {
          ...Theme.Fonts.Ribbon.FolderIconAmount,
        },
      },
    };
  }

  set amount(amount) {
    this.tag('Amount').text.text = amount;
  }
}
